export const Footer = () => (
    <footer className="bg-navy text-white py-5 font-bold text-center">
        <p className="m-0">1605 Palmales Ct., Las Vegas, NV 89128 &nbsp; Phone: (858) 324-1903 &amp; (702) 430-8892</p>
    </footer>
);
